module.exports = __webpack_public_path__ + "static/cart08-d2420af8c020c6d8ec289680e90a86d4.svg";